import { ICadastroTemplateMensagemAtiva } from "../../../Interfaces/HelpDesk/GestaoTemplate/GestaoTemplateInterace";
import {
    CadastrarTemplateMensagemAtivaService,
    EditarTemplateMensagemAtivaService,
    ListarTemplateMensagemAtivaService,
    ObterTemplateMensagemAtivaService,
    ObterValoresVariaveisMensagemAtivaService,
    RemoverTemplateMensagemAtivaService,
    RemoverVariaveisMensagemAtivaService,
    RemoverVariavelMensagemAtivaService,
} from "../../../Services/HelpDesk/GestaoTemplate/GestaoTemplateService";
import { Controller } from "../../Controller";

export async function ListarTemplateMensagemAtivaController() {
    return Controller(ListarTemplateMensagemAtivaService());
}

export async function ObterTemplateMensagemAtivaController(
    idDocumentoTemplate: number
) {
    return Controller(ObterTemplateMensagemAtivaService(idDocumentoTemplate));
}

export async function CadastrarTemplateMensagemAtivaController(
    requestBody: ICadastroTemplateMensagemAtiva
) {
    return Controller(CadastrarTemplateMensagemAtivaService(requestBody));
}

export async function EditarTemplateMensagemAtivaController(
    idDocumentoTemplate: number,
    requestBody: ICadastroTemplateMensagemAtiva
) {
    return Controller(
        EditarTemplateMensagemAtivaService(idDocumentoTemplate, requestBody)
    );
}

export async function RemoverTemplateMensagemAtivaController(
    idDocumentoTemplate: number
) {
    return Controller(RemoverTemplateMensagemAtivaService(idDocumentoTemplate));
}

export async function RemoverVariavelMensagemAtivaController(
    idVariavelTemplate: number
) {
    return Controller(RemoverVariavelMensagemAtivaService(idVariavelTemplate));
}

export async function RemoverVariaveisMensagemAtivaController(
    requestBody: Array<number>
) {
    return Controller(RemoverVariaveisMensagemAtivaService(requestBody));
}

export async function ObterValoresVariaveisMensagemAtivaController(
    nrCliente: string,
    idTemplate: number
) {
    return Controller(
        ObterValoresVariaveisMensagemAtivaService(nrCliente, idTemplate)
    );
}
